"use client";

import { useState } from "react";

import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  heading: string;
  items: FAQItem[];
}

function FAQAccordionItem({ item }: { item: FAQItem }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-2xl border border-ash-200 bg-white">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between px-6 py-5 text-left"
      >
        <h3 className="pr-4 font-clash text-lg font-medium text-ash-900 md:text-xl">{item.question}</h3>
        <ChevronDown
          className={cn("size-5 shrink-0 text-ash-400 transition-transform duration-200", open && "rotate-180")}
        />
      </button>
      {open && (
        <div className="border-t border-ash-200 px-6 py-5">
          <p className="text-base leading-relaxed text-ash-600">{item.answer}</p>
        </div>
      )}
    </div>
  );
}

export function FAQAccordion({ heading, items }: FAQAccordionProps) {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-6">
        <h2 className="mb-10 font-clash text-3xl font-medium leading-tight tracking-snug text-ash-900 md:text-5xl">
          {heading}
        </h2>
        <div className="space-y-4">
          {items.map((item) => (
            <FAQAccordionItem key={item.question} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
